import React, { useRef, useState } from "react";
import { Upload, Loader2, FileText, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function DocUpload({ docs, setDocs, testid = "fr-doc-upload" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/franchise/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setDocs((d) => [...d, data]);
      } catch (err) { toast.error(`${file.name}: ${formatApiError(err.response?.data?.detail) || "upload failed"}`); }
    }
    setBusy(false);
  };
  return (
    <div>
      <input ref={ref} type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid}>
        {busy ? <Loader2 size={15} className="mr-2 animate-spin" /> : <Upload size={15} className="mr-2" />} {busy ? "Uploading..." : "Upload documents"}
      </Button>
      <p className="text-xs text-muted-foreground mt-1">PDF, image or Word, up to 10 MB each — e.g. registration certificate, ID proof of representative, institute photos.</p>
      {docs.length > 0 && (
        <ul className="mt-3 space-y-2">
          {docs.map((d, i) => (
            <li key={d.path} className="flex items-center gap-2 text-sm bg-muted/50 rounded-md px-3 py-2" data-testid={`fr-doc-${i}`}>
              <FileText size={15} className="text-amber" /><span className="flex-1 truncate">{d.name}</span>
              <button type="button" onClick={() => setDocs((x) => x.filter((_, j) => j !== i))} aria-label="Remove"><X size={15} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
